import API from "./API"
import { BASE_URL } from "@/constants"

const resource = "/fields/"

const moveClientResource = "/move-client-task-view/"

const duplicateBoundaryResource = "/duplicate-boundary-management/"

const fieldInputAnalyticsResource = "/field-input-analytics/"

// With the backend's lazy_boundary_images flag on, boundary_image is an API-relative
// redirect link (/api/v1/field-boundary-image/...) rather than a presigned S3 URL. The app
// is served from a different origin than the API, so it has to be made absolute before it
// lands in an <img src>.
const absolutizeBoundaryImages = response => {
  for (const field of response.data) {
    if (field.boundary_image?.startsWith("/")) {
      field.boundary_image = `${BASE_URL}${field.boundary_image.slice(1)}`
    }
  }
  return response
}

const list = () => API.get(resource).then(absolutizeBoundaryImages)

const get = fieldId =>
  API.get(`${resource}?requested_field_id=${fieldId}`).then(absolutizeBoundaryImages)

const fieldDelete = fieldId => API.post(`${resource}${fieldId}/field_delete/`)

const batchDelete = fieldIds =>
  API.post(`${resource}batch_delete/`, { field_ids: fieldIds })

const ignoreGeoPackages = payload =>
  API.post(`${resource}ignore_geo_packages/`, payload)

const fetchGeoPkgsByDataType = payload =>
  API.post(`${resource}fetch_geo_packages_by_data_type/`, payload)

const downloadDataSpreadsheet = ({ fieldId }) =>
  API.post(`${resource}${fieldId}/download_data_spreadsheet/`)

const updateFieldName = payload =>
  API.post(`${resource}update_field_name/`, payload)

const deleteYearData = payload =>
  API.post(`${resource}delete_year_data/`, payload)

const lockYearData = payload => API.post(`${resource}lock_year_data/`, payload)

const fetchClientOrgOptions = () =>
  API.post(`${moveClientResource}fetch_client_org_options/`)

const fetchTargetCorpOptions = () =>
  API.post(`${moveClientResource}fetch_target_corp_options/`)

const getMoveClientTasks = () => API.get(moveClientResource)

const deleteMoveClientTask = id => API.delete(`${moveClientResource}${id}`)

const getRenameHierarchyJobs = () => API.get("rename-hierarchy/")

const postRenameHierarchyJob = payload => API.post("rename-hierarchy/", payload)

const deleteRenameHierarchyJob = id => API.delete(`rename-hierarchy/${id}/`)

const createMoveClientTask = payload =>
  API.post(`${moveClientResource}`, payload)

const getFeatureFlags = () => API.get("/feature-flags/")

const fetchUneditableFields = () =>
  API.post(`${resource}fetch_uneditable_fields/`)

const getClientProfile = () => API.get("client-profile/")
const getCorpList = () => API.get("corp-list/")

const saveClientProfile = payload =>
  API.put(`/client-profile/${payload.id}/`, payload)

const generateLOI = payload => API.post("/generate-loi/", payload)

const sendLOIForSignature = payload =>
  API.post("/send-loi-for-signature/", payload)

const confirmCropPlantingSource = payload =>
  API.post(`${resource}confirm_field_crop/`, payload)

const postESignReleaseForm = payload =>
  API.post("/send-release-form-for-signature/", payload)

const postManageLayers = payload =>
  API.post(`${resource}manage_layers/`, payload)

const getBoundaryManagement = payload => {
  return API.get(duplicateBoundaryResource, { params: payload })
}

const fetchBoundaryDetail = payload =>
  API.post(`${duplicateBoundaryResource}fetch_boundary_detail/`, payload)

const archiveFields = payload =>
  API.post(`${duplicateBoundaryResource}archive_fields/`, payload)

const downloadBoundary = payload =>
  API.post(`${duplicateBoundaryResource}export_shapefile/`, payload)

const fetchFIAData = () =>
  API.get(`${fieldInputAnalyticsResource}`)

const fetchSearchFilterOptions = () =>
  API.post(`${fieldInputAnalyticsResource}fetch_search_filter_options/`)

const filteredAnalytics = payload =>
  API.post(`${fieldInputAnalyticsResource}filtered_analytics/`, payload)

const favoriteVariety = payload =>
  API.post(`${fieldInputAnalyticsResource}favorite_variety/`, payload)

const kbChat = payload => API.post(`${fieldInputAnalyticsResource}kb_chat/`, payload)

export default {
  list,
  get,
  fieldDelete,
  batchDelete,
  fetchGeoPkgsByDataType,
  ignoreGeoPackages,
  downloadDataSpreadsheet,
  updateFieldName,
  deleteYearData,
  lockYearData,
  fetchClientOrgOptions,
  getMoveClientTasks,
  deleteMoveClientTask,
  createMoveClientTask,
  getFeatureFlags,
  fetchTargetCorpOptions,
  fetchUneditableFields,
  getRenameHierarchyJobs,
  postRenameHierarchyJob,
  deleteRenameHierarchyJob,
  getClientProfile,
  getCorpList,
  saveClientProfile,
  generateLOI,
  sendLOIForSignature,
  confirmCropPlantingSource,
  postESignReleaseForm,
  postManageLayers,
  getBoundaryManagement,
  fetchBoundaryDetail,
  downloadBoundary,
  archiveFields,
  fetchFIAData,
  fetchSearchFilterOptions,
  filteredAnalytics,
  favoriteVariety,
  kbChat,
}
